import { render, staticRenderFns } from "./tableMess.vue?vue&type=template&id=67b2b9c6&scoped=true&slot-scope=scope&"
import script from "./tableMess.vue?vue&type=script&lang=js&"
export * from "./tableMess.vue?vue&type=script&lang=js&"
import style0 from "./tableMess.vue?vue&type=style&index=0&id=67b2b9c6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b2b9c6",
  null
  
)

export default component.exports